import React from 'react';
import {Route, Switch, Link} from 'react-router-dom';
import {ListGroupItem, Button} from "reactstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlus} from "@fortawesome/free-solid-svg-icons";

import APITable2 from "../../../../Components/APITable2";
import APIForm from "../../../../Components/APIForm";
import {useTranslation} from "react-i18next";


const API_PATH = 'store/custom_fields';


const TableHeader = () => {
    const {t, i18n} = useTranslation();
    return <ListGroupItem>
        <div className="widget-content py-1 px-0 px-md-2">
            <div className="widget-content-wrapper text-secondary">
                <div className="widget-content-left" style={{width: 150}}>
                    {t('settings.custom_fields.column.name', 'Name')}
                </div>
                <div className="widget-content-left" style={{width: 100}}>
                    {t('settings.custom_fields.column.type', 'Type')}
                </div>
                <div className="widget-content-right d-none d-sm-block" style={{width: 'calc(100% - 350px)'}}>
                    {t('settings.custom_fields.column.description', 'Description')}
                </div>
                <div className="widget-content-right" style={{width: 50}}>

                </div>
            </div>
        </div>
    </ListGroupItem>;
};


const TableRow = (
    {
        data,
        setIdSelected,
        actionClick,
        actionDelete,
    }
) => {
    const {t, i18n} = useTranslation();
    /**
     * Рендеринг
     */
    return <ListGroupItem
        className='hover-bg-light'
        onClick={() => actionClick(data.id)}
    >
        <div className="widget-content py-1 px-0 px-md-2">
            <div className='widget-content-wrapper'>
                <div className="widget-content-left" style={{width: 150}}>
                    <strong>{data.name}</strong>
                </div>
                <div className="widget-content-left" style={{width: 100}}>
                    {t(data.dtype.name)}
                </div>
                <div className="widget-content-right d-none d-sm-block" style={{width: 'calc(100% - 350px)'}}>
                    <span className="text-secondary opacity-7">{data.description}</span>
                </div>
                <div className="widget-content-right text-right" style={{width: 50, paddingTop: 4}}>
                    <i className="pe-7s-trash mr-2 fsize-2 hover-text-danger hover-pointer" onClick={(e) => {
                        e.stopPropagation();

                        setIdSelected(data.id);
                        actionDelete();
                    }}/>
                </div>
            </div>
        </div>
    </ListGroupItem>;
};


const CustomFields = ({url}) => {
    const {t, i18n} = useTranslation();

    return <Switch>
            <Route exact path={`${url}/create/`} render ={() => <>
                <APIForm
                    apiPath={API_PATH}
                    modelId={undefined}
                    method='post'
                    actionRedirectUrl={`${url}/`}
                    deletionDisabled={true}
                />
            </>} />
            <Route exact path={`${url}/:id(\\d+)/`} render ={props => <>
                <APIForm
                    apiPath={API_PATH}
                    modelId={props.match.params.id}
                    method='patch'
                    actionRedirectUrl={`${url}/`}
                />
            </>} />
            <Route exact path={`${url}/`} render ={() => <>
                <div className="d-flex justify-content-end mb-3">
                    <Link to={`${url}/create/`}>
                        <Button color="success" size="lg">
                            <FontAwesomeIcon icon={faPlus}/>
                            &nbsp;&nbsp;{t('layout.page_title.button_create', 'Create')}
                        </Button>
                    </Link>
                </div>
                <APITable2
                    HeaderComponent={TableHeader}
                    RowComponent={TableRow}
                    emptyMessage={t('settings.custom_fields.list.no_data', 'No variables')}
                    deleteMessage={t('settings.custom_fields.list.confirmation.remove', 'Are you sure you want to remove the variable?')}
                    apiPath={API_PATH}
                />
            </>} />
    </Switch>;
};

export default CustomFields;
